import { getDynamicPricingExperimentEntryStatus } from 'api/recommendations'
import { isEligibleForLereDynamicPricingAbTest } from 'checkout/lib/utils/lereDynamicPricing'
import { LabFeatureFlags } from 'constants/lab'

/** True if the member was previously admitted via a LERE experiment entry point. */
export async function hasEnteredLereDynamicPricingExperiment(memberId?: string): Promise<boolean> {
  if (!isEligibleForLereDynamicPricingAbTest() || !memberId) {
    return false
  }

  try {
    return await getDynamicPricingExperimentEntryStatus(memberId)
  } catch {
    return false
  }
}

/** Include the LERE pricing flag only for previously admitted experiment entrants. */
export function getLabFeatureFlagsForLereDynamicPricingExperiment(
  configuredLabFeatureFlags: ReadonlyArray<string>,
  hasEnteredLereDynamicPricingExperiment: boolean,
): Array<string> {
  if (!hasEnteredLereDynamicPricingExperiment || configuredLabFeatureFlags.includes(LabFeatureFlags.enableLereDynamicPricingGroup)) {
    return [...configuredLabFeatureFlags]
  }
  return [...configuredLabFeatureFlags, LabFeatureFlags.enableLereDynamicPricingGroup]
}
